import { combineReducers, Reducer, AnyAction } from '@reduxjs/toolkit';

import reducerProjects from './reducers/reducerProjectsList'
import reducerGetRoutes from "./reducers/reducerRoutesList";
import reducerGetVacantRoutes from './reducers/reducerVacantRoutesList';
import reducerGetVacantRoutesNoModal from './reducers/reduserVacantRoutesListNoModal';

interface ProjectReducers {
    projects: Reducer<any, AnyAction>;
    routes: Reducer<any, AnyAction>;
    vacantRoutes: Reducer<any, AnyAction>;
    vacantRoutesNoModal: Reducer<any, AnyAction>;
}

const ProjectsStore = combineReducers<ProjectReducers>({
    projects: reducerProjects,
    routes: reducerGetRoutes,
    vacantRoutes: reducerGetVacantRoutes,
    vacantRoutesNoModal: reducerGetVacantRoutesNoModal
});

export default ProjectsStore